// extracted by mini-css-extract-plugin
export default {"lessonSubjectsContainer":"LessonSubjects_lessonSubjectsContainer__PTwu0","header":"LessonSubjects_header__kVFfa"};